import { AxiosError } from 'axios';
import { PendingReleaseEventResponse } from '@data/blockReleases/types/PendingReleaseEvent.types';

export const shouldDisableErrorHandlerByCode = (codes: string[] = []) => (error: AxiosError<PendingReleaseEventResponse>): boolean => {
	const code = error.response?.data.code;
	return Boolean(code && codes.includes(code));
};
